<template>
  <i-modal
    v-model="modal"
    @on-visible-change="onVisibleChange"
    title="コンバート送信結果履歴"
    width="780"
    :mask-closable="false"
    footer-hide
    class="modal-convert-history"
  >
    <div class="portalsite_name">
      {{ history.portalsite_name }}
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>回</th>
          <th>送信開始時間</th>
          <th>送信終了時間</th>
          <th>送信結果</th>
        </tr>
      </thead>
      <tr v-if="history.history && history.history.length === 0">
        <td colspan="4">
          <div class="no_data">
            コンバート送信履歴がありません。
          </div>
        </td>
      </tr>
      <tr v-for="(data, dataIdx) in history.history" :key="dataIdx">
        <td>{{ data.count }}</td>
        <td>{{ data.started_at_date }}</td>
        <td>{{ data.ended_at_date }}</td>
        <td>
          <i-button type="primary" size="small" @click="onClickDetail(data.convert_result_id)">詳細</i-button>
        </td>
      </tr>
    </table>
  </i-modal>
</template>

<script>
import { Modal, Button } from 'view-design'
import ConvertRepository from '@/repositories/convertRepository'
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
  },
  data() {
    return {
      history: {},
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalConvertHistory/getModal']
      },
      set(val) {
        this.$store.commit('ModalConvertHistory/setModal', val)
      },
    },
    shopId() {
      return this.$store.getters['ModalConvertHistory/getShopId']
    },
    portalSiteCd() {
      return this.$store.getters['ModalConvertHistory/getPortalSiteCd']
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        this.getHistory()
      } else {
        setTimeout(this.resetParam, 300)
      }
    },
    // コンバート履歴 取得処理
    async getHistory() {
      this.$store.dispatch('Loading/setLoading', true)
      await ConvertRepository.getHistory(this.shopId, this.portalSiteCd)
        .then(res => {
          if (res.result) {
            this.history = res.data
          } else {
            alert('データ取得に失敗しました。')
            this.modal = false
          }
        })
        .catch(e => {
          console.log(e)
          alert('データ取得に失敗しました。')
          this.modal = false
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // コンバート詳細ボタン
    async onClickDetail(resultId) {
      const params = { resultId: resultId }
      this.$store.dispatch('ModalConvertDetail/set', params)
    },
    // パラメータをリセットする
    resetParam() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      this.$store.dispatch('ModalConvertHistory/reset')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-convert-history {
  .portalsite_name {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: bold;
  }
  .table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 0;
    th,
    td {
      padding: 4px 0;
      border: 1px solid #cfcfcf;
      text-align: center;
    }
    th {
      background-color: #f0f0f0;
    }
  }
  .no_data {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
}
</style>
